import { GetResultsResponse } from "../generated-api-proxy";
import { AnalysisViewModel } from "./analysis-view-model";
import { GamtestViewModel } from "./gamtest-view-model";
import { TotalResultViewModel } from "./total-result-view-model";

export class ResultViewModel {
  total: TotalResultViewModel = TotalResultViewModel.empty();

  gamtest: GamtestViewModel = GamtestViewModel.empty();

  analysis: AnalysisViewModel = AnalysisViewModel.empty();

  recommendationKeys: string[] = [];

  constructor(result: GetResultsResponse | null) {
    if (!result) {
      return;
    }

    if (result.total) {
      this.total = new TotalResultViewModel(result.total);
    }

    if (result.gamtest) {
      this.gamtest = new GamtestViewModel(result.gamtest);
    }

    if (result.analysis) {
      this.analysis = new AnalysisViewModel(result.analysis);
    }

    if (result.recommendations) {
      this.recommendationKeys = result.recommendations;
    }
  }

  static empty(): ResultViewModel {
    return new ResultViewModel(null);
  }
}
